<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">Manage Jobs</h5>
          </div>

          <div class="card-body">
            <div class="col-6">
              <el-switch
                style="display: block"
                v-model="showCompletedJobs"
                active-color="#13ce66"
                inactive-color="#ad466c"
                active-text="Show Completed Jobs"
              >
              </el-switch>
            </div>
            <el-button
              type="primary"
              size="medium"
              style="float: right"
              class="mb-4"
              @click="() => (showModal = true)"
              >Add Job</el-button
            >
            <!-- TABLE -->
            <el-table :data="tableData">
              <el-table-column
                prop="completed"
                label="Completed"
                sortable
                width="180"
              >
                <template slot-scope="scope">
                  <el-switch
                    active-color="#13ce66"
                    inactive-color="#ad466c"
                    v-model="scope.row.completed"
                    @change="changeStatus(scope.row)"
                    class="onoffswitch"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="Edit" width="180">
                <template slot-scope="scope">
                  <el-dropdown
                    class="inlineButton"
                    trigger="click"
                    @command="handleCommand"
                    size="small"
                  >
                    <el-button type="primary">
                      <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="el-icon-edit"
                        :command="{
                          action: 'edit',
                          data: scope.row,
                          index: scope.$index
                        }"
                        >Edit</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-delete"
                        divided
                        :command="{
                          action: 'delete',
                          data: scope.row,
                          index: scope.$index
                        }"
                        >Delete</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="Description" sortable>
              </el-table-column>
              <el-table-column
                prop="customerDisplayName"
                label="Customer"
                sortable
              >
              </el-table-column>
            </el-table>
          </div>

          <!-- ADD JOB MODAL -->

          <el-dialog
            :visible.sync="showModal"
            @closed="clearJob"
            class="custom-el-modal"
          >
            <h6 slot="title">
              {{ editModal ? 'Edit Job' : 'Add Job' }}
            </h6>
            <span class="form-group">
              <el-form label-position="left" class="validationError">
                <el-form-item label="Job Description:">
                  <el-input
                    type="text"
                    id="name"
                    name="name"
                    style="width:50%"
                    maxlength="25"
                    show-word-limit
                    v-model="selectedJob.description"
                    class="el-dark-input"
                  />
                </el-form-item>
                <el-form-item label="Customer:">
                  <el-select
                    id="customer"
                    name="customer"
                    style="width:50%"
                    v-model="selectedJob.customer"
                    class="el-dark-input"
                    value-key="id"
                  >
                    <!-- <div > -->
                    <el-option
                      v-for="customer in customers"
                      :key="customer.id"
                      :label="customer.displayName"
                      :value="customer"
                    ></el-option>
                    <!-- </div> -->
                  </el-select>
                </el-form-item>
              </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showModal = false">Cancel</el-button>
              <el-button v-if="!editModal" type="primary" @click="addJob"
                >Confirm</el-button
              >
              <el-button v-else type="primary" @click="editJob">Edit</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../assets/js/firebase/db.js';

export default {
  name: 'manageJobs',
  components: {},
  props: {
    customers: Array
  },
  data() {
    return {
      showModal: false,
      editModal: false,
      selectedJob: {
        description: null,
        customer: null
      },
      showCompletedJobs: false
    };
  },
  methods: {
    //handles the command from the dropdown(either edit or delete)
    handleCommand(data) {
      //if command is delete, delete job
      if (data.action === 'delete') {
        try {
          db.collection('jobs')
            .doc(data.data.id)
            .update({ deleted: true })
            .then(() => {
              this.tableData.splice(data.index, 1);
              this.showSuccess('Job successfully deleted');
            });
        } catch (error) {
          this.showError('Error deleting job');
          console.log(error);
        }
        //if command is edit, populate the modal and open it
      } else if (data.action === 'edit') {
        this.editModal = true;
        this.populateModal(data.data);
        this.showModal = true;
      }
    },
    populateModal(data) {
      //find customer by id
      let customer = this.customers.find(x => x.id === data.customerID);
      this.selectedJob = {
        description: data.description,
        customer: customer,
        id: data.id
      };
    },
    addJob() {
      if (this.validateEntry()) {
        try {
          //format the data from the modal before we send to firebase
          let formattedData = {
            description: this.selectedJob.description.trim(),
            customerDisplayName: this.selectedJob.customer.displayName,
            customerID: this.selectedJob.customer.id,
            customer: this.selectedJob.customer.customerName,
            date: new Date(Date.now()),
            jobNum: null,
            completed: false,
            org: this.$store.state.userCompany,
            deleted: false
          };
          //send the formatted data to firebase
          db.collection('jobs')
            .add(formattedData)
            .then(doc => {
              //update the store, which will update the table
              formattedData['id'] = doc.id;
              let updatedJobs = JSON.parse(
                JSON.stringify(this.$store.state.jobs)
              );
              updatedJobs.push(formattedData);

              this.$store.commit('updateJobs', updatedJobs);

              this.showModal = false;
              this.showSuccess('Job successfully added');
            });
        } catch (error) {
          console.log(error);
          this.showError('Error adding job');
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    editJob() {
      if (this.validateEntry()) {
        try {
          //format the data from the modal before we send to firebase
          let formattedData = {
            description: this.selectedJob.description.trim(),
            customerDisplayName: this.selectedJob.customer.displayName,
            customerID: this.selectedJob.customer.id,
            customer: this.selectedJob.customer.customerName,
            date: new Date(Date.now()),
            jobNum: null,
            completed: false,
            org: this.$store.state.userCompany,
            deleted: false
          };
          //send the formatted data to firebase

          db.collection('jobs')
            .doc(this.selectedJob.id)
            .update(formattedData)
            .then(() => {
              //update the store, which will update the table
              formattedData['id'] = this.selectedJob.id;
              let updatedJobs = JSON.parse(
                JSON.stringify(this.$store.state.jobs)
              );
              let index = updatedJobs.findIndex(
                x => x.id === this.selectedJob.id
              );

              updatedJobs.splice(index, 1, formattedData);
              this.$store.commit('updateJobs', updatedJobs);
              this.showModal = false;
              this.showSuccess('Job succesfully updated');
            });
        } catch (error) {
          this.showError('Error updating job');

          console.log(error);
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    clearJob() {
      this.editModal = false;
      this.selectedJob = {
        name: null,
        customer: null
      };
    },
    //change enabled status
    changeStatus: function(data) {
      try {
        db.collection('jobs')
          .doc(data.id)
          .update({ completed: data.completed })
          .then(() => {
            //update the store
            let updatedJobs = JSON.parse(
              JSON.stringify(this.$store.state.jobs)
            );
            let index = updatedJobs.findIndex(
              x => x.id === this.selectedJob.id
            );

            updatedJobs.splice(index, 1, data);
            this.$store.commit('updateJobs', updatedJobs);
          });
      } catch (error) {
        this.showError('Error updating job status');

        console.log(error);
      }
    },

    //validate modal entry
    //TODO: highlight where validation errors are in the modal
    validateEntry() {
      if (
        this.selectedJob.description === null ||
        this.selectedJob.description.trim() === ''
      ) {
        return false;
      }
      return true;
    },

    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    }
  },
  computed: {
    tableData() {
      if (!this.showCompletedJobs) {
        return this.$store.state.jobs.filter(x => x.completed === false);
      } else {
        return this.$store.state.jobs;
      }
    }
  }
};
</script>
<style>
/* TODO: improve visuals of modal */
.el-dialog__header {
  background-color: #ad466c;
}
.el-dialog__body {
  background-color: #353f53;
}
.el-dialog__footer {
  background-color: #353f53;
}
.el-form-item__label {
  color: white !important;
}
/* .el-switch__core.is-checked {
  background-color: #ad466c !important;
  border-color: #ad466c !important;
} */
.el-switch__label {
  /* color: white !important; */
  color: #ad466c !important;

  /* font-size: 30px !important; */
  position: relative;
  /* width: 10%; */
  display: inline-block;
  vertical-align: middle;
}
.el-switch__label.is-active {
  color: #ad466c !important;
  /* -webkit-text-stroke-width: 0.4px;
  -webkit-text-stroke-color: white; */
}
.onoffswitch {
  /* background-color: #ad466c !important; */
  color: #ad466c !important;
  position: relative;
  /* width: 25%; */
  display: inline-block;
  /* vertical-align: middle; */
}
.validationError {
  border-color: red;
  border-width: thick;
}

.el-table tr {
  background-color: #353f53 !important;
  color: white !important;
}
.el-table th {
  background-color: #353f53 !important;
  color: white !important;
}
.el-table tr:hover {
  background-color: blue !important;
  background: red;
}
.el-table td {
  background-color: #353f53 !important;
}
</style>
